import { tsrContractsClient } from '@/api/tsrContractsClient';
import { QueryKey } from '@/data/query';
import type { GetPatientDetailsInclude } from '@montugroup/pms-api-contracts';
import { GetPatientDetailsIncludeEnum } from '@montugroup/pms-api-contracts';

export const updatePatientDetailsClient = tsrContractsClient.patientDetailsContract;

type AutoSaveForms = Exclude<GetPatientDetailsInclude, 'patient-red-flag-info'>;

/**
 * Custom hook for updating patient details
 *
 * @param type GetPatientDetailsInclude - schema type
 * @returns Promise
 */

export function useUpdatePatientDetails(type: GetPatientDetailsInclude | undefined) {
  const { mutateAsync, ...rest } = updatePatientDetailsClient.updatePatientDetails.useMutation({
    mutationKey: [QueryKey.PatchPatientData, type],
  });

  return {
    ...rest, // rest of the useQuery props
    mutateAsync: (patientId: number, attributes: object) => {
      if (type && !GetPatientDetailsIncludeEnum.options.includes(type)) {
        return Promise.reject('updatePatientDetails: type is invalid.');
      }
      if (!patientId || !type) {
        return Promise.reject('updatePatientDetails: patientId and a valid type is required.');
      }

      return mutateAsync({
        body: {
          data: [
            {
              type: type as AutoSaveForms,
              id: patientId,
              attributes,
            },
          ],
        },
        params: {
          id: patientId,
        },
      });
    },
  };
}
